module.exports = __webpack_public_path__ + "static/media/Copy of IMG_3350.9d031f05.png";